<template>
    <v-dialog v-model="modalVisible" persistent max-width="600">
        <v-card v-if="startupMessage">
            <v-card-title class="headline font-weight-bold mb-2">
                {{ $t('startupmessage.title') }}
            </v-card-title>
            <v-card-text class="pb-0 pt-0">
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div v-html="localizedMessage"></div>
                <v-checkbox v-model="dontShowAgain" :label="$t('startupmessage.tooltip.text')" hide-details class="mt-4" />
            </v-card-text>
            <v-card-actions class="justify-end pr-6 pb-4">
                <v-btn color="primary" variant="flat" @click="closeDialog">
                    {{ $t('startupmessage.button.confirm') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-facing-decorator';
import { namespace } from 'vuex-facing-decorator';

import { NAME as NAME_SECURITY } from '@/store/modules/security';
const securityModul = namespace(NAME_SECURITY);
import { DISMISS_STARTUP_MESSAGE } from '@/store/modules/security/actions';
import { GETMODALSTARTUPMESSAGEVISIBLE, GETSTARTUPMESSAGE } from '@/store/modules/security/getters';
import { StartupMessage } from '@/services/startupMessageService';

@Component
export default class StartupMessageDialog extends Vue {
    @securityModul.Getter(GETMODALSTARTUPMESSAGEVISIBLE) modalVisible!: boolean;
    @securityModul.Getter(GETSTARTUPMESSAGE) startupMessage!: StartupMessage;
    @securityModul.Action(DISMISS_STARTUP_MESSAGE) dismissStartupMessage!: Function;
    private dontShowAgain = false;

    private get isFrench() {
        return this.$i18n.locale.toLowerCase() === 'fr';
    }

    private get localizedMessage() {
        if (!this.startupMessage) {
            return '';
        }
        return this.isFrench ? this.startupMessage.messageFr : this.startupMessage.messageDe;
    }

    private closeDialog() {
        console.log('close dialog clicked');
        this.dismissStartupMessage(this.dontShowAgain);
    }
}
</script>
